module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael P. Steinberg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Michael P. Steinberg")]), _vm._v(" is president of the American Academy in Berlin and Barnaby Conrad and Mary Critchfield Keeney Professor of History and professor of music and German studies at Brown University. He is the author, most recently, of "), _c('I', [_vm._v("Judaism Musical and Unmusical")]), _vm._v(", also published by the University of Chicago Press."), _c('br'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4yhkHP/tc-custom/9780226594224.jpg?1731797656785",
      "alt": "This image is the cover for the book Trouble with Wagner"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Trouble with Wagner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this unique and hybrid book, cultural and music historian Michael P. Steinberg combines a close analysis of Wagnerian music drama with a personal account of his work as a dramaturg on the bicentennial production of "), _c('i', [_vm._v("The Ring of the Nibelung")]), _vm._v(" for the Teatro alla Scala Milan and the Berlin State Opera"), _c('i', [_vm._v(".")]), _vm._v(" Steinberg shows how Wagner uses the power of a modern mythology to heighten music’s claims to knowledge, thereby fusing not only art and politics, but truth and lies as well. Rather than attempting to separate value and violence, or “the good from the bad,” as much Wagner scholarship as well as popular writing have tended to do, Steinberg proposes that we confront this paradox and look to the capacity of the stage to explore its depths and implications.  "), _c('br'), _c('br'), _vm._v(" Drawing on decades of engagement with Wagner and of experience teaching opera across disciplines, "), _c('i', [_vm._v("The Trouble with Wagner")]), _vm._v(" is packed with novel insights for experts and interested readers alike."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0